import { render, staticRenderFns } from "./KeyGroupCreation.vue?vue&type=template&id=74c00a3f&"
import script from "./KeyGroupCreation.vue?vue&type=script&lang=ts&"
export * from "./KeyGroupCreation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports